import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=6dd575ca&scoped=true&"
import script from "./InputLabel.vue?vue&type=script&lang=js&"
export * from "./InputLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=6dd575ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd575ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd575ca')) {
      api.createRecord('6dd575ca', component.options)
    } else {
      api.reload('6dd575ca', component.options)
    }
    module.hot.accept("./InputLabel.vue?vue&type=template&id=6dd575ca&scoped=true&", function () {
      api.rerender('6dd575ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Text/InputLabel.vue"
export default component.exports